var pl_PL = {};
pl_PL.strings = {
  addMore: 'Dodaj więcej',
  addMoreFiles: 'Dodaj więcej plików',
  addingMoreFiles: 'Dodawanie plików',
  allowAccessDescription: 'In order to take pictures or record video with your camera, please allow camera access for this site.',
  allowAccessTitle: 'Zezwól na dostęp do kamery',
  authenticateWith: 'Przejdź do %{pluginName}',
  authenticateWithTitle: 'Przejdź do %{pluginName}, aby wybrać pliki',
  back: 'Wróć',
  browse: 'przeglądaj',
  cancel: 'Anuluj',
  cancelUpload: 'Anuluj przesyłanie',
  chooseFiles: 'Wybierz pliki',
  closeModal: 'Zamknij okno',
  companionAuthError: 'Wymagane uwierzytelnienie',
  companionError: 'Nie udało się połączyć',
  companionUnauthorizeHint: 'Aby cofnąć dostęp do konta %{provider}, przejdź do %{url}',
  complete: 'Zakończono',
  connectedToInternet: 'Połączono z siecią',
  copyLink: 'Kopiuj link',
  copyLinkToClipboardFallback: 'Skopiuj link poniżej',
  copyLinkToClipboardSuccess: 'Link skopiowany do schowka',
  creatingAssembly: 'Przygotowywanie plików...',
  creatingAssemblyFailed: 'Transloadit: Nie udało się stworzyć Assembly',
  dashboardTitle: 'Prześlij pliki',
  dashboardWindowTitle: 'Okno przesyłania plików (Naciśnij escape, aby zamknąć)',
  dataUploadedOfTotal: '%{complete} z %{total}',
  done: 'Zakończ',
  dropHereOr: 'Upuść pliki lub %{browse}',
  dropHint: 'Upuść pliki, które chcesz przesłać',
  dropPaste: 'Upuść pliki, wklej lub %{browse}',
  dropPasteFiles: 'Upuść pliki tutaj, wklej lub %{browse}',
  dropPasteImport: 'Upuść pliki, wklej, %{browse} lub importuj',
  edit: 'Edytuj',
  editFile: 'Edytuj plik',
  editing: 'Edycja %{file}',
  emptyFolderAdded: 'Nie dodano żadnego pliku z pustego katalogu',
  encoding: 'Kodowanie...',
  enterCorrectUrl: 'Nieprawidłowy URL: Upewnij się, że podajesz bezpośredni link do pliku',
  enterUrlToImport: 'Wprowadź URL, aby zaimportować plik',
  exceedsSize: 'Ten plik przekracza dopuszczalny rozmiar',
  failedToFetch: 'Companion failed to fetch this URL, please make sure it’s correct',
  failedToUpload: 'Nie udało się przesłać pliku %{file}',
  fileSource: 'Źródło: %{name}',
  filesUploadedOfTotal: {
    '0': '%{complete} z %{smart_count} przesłanych plików',
    '1': '%{complete} z %{smart_count} przesłanych plików',
    '2': '%{complete} z %{smart_count} przesłanych plików'
  },
  filter: 'Filter',
  finishEditingFile: 'Zakończ edycję pliku',
  folderAdded: {
    '0': 'Dodano %{smart_count} plik z %{folder}',
    '1': 'Dodano %{smart_count} pliki z %{folder}',
    '2': 'Dodano %{smart_count} pliki z %{folder}'
  },
  generatingThumbnails: 'Generowanie miniaturek...',
  import: 'Import',
  importFrom: 'Import z %{name}',
  link: 'Link',
  loading: 'Ładowanie...',
  logOut: 'Wyloguj się',
  myDevice: 'Moje urządzenie',
  noFilesFound: 'Nie znaleziono plików ani katalogów',
  noInternetConnection: 'Brak połączenia z Internetem',
  openFolderNamed: 'Otwórz folder %{name}',
  pause: 'Zatrzymaj',
  pauseUpload: 'Zatrzymaj przesyłanie',
  paused: 'Zatrzymano',
  poweredBy: 'Powered by',
  preparingUpload: 'Przygotowanie...',
  processingXFiles: {
    '0': 'Przetwarzanie %{smart_count} pliku',
    '1': 'Przetwarzanie %{smart_count} plików',
    '2': 'Przetwarzanie %{smart_count} plików'
  },
  removeFile: 'Usuń plik',
  resetFilter: 'Resetuj filtr',
  resume: 'Wznów',
  resumeUpload: 'Wznów przesyłanie',
  retry: 'Spróbuj ponownie',
  retryUpload: 'Ponów przesyłanie',
  saveChanges: 'Zapisz zmiany',
  selectAllFilesFromFolderNamed: 'Zaznacz wszystkie pliki z katalogu %{name}',
  selectFileNamed: 'Zaznacz plik %{name}',
  selectX: {
    '0': 'Zaznacz %{smart_count}',
    '1': 'Zaznacz %{smart_count}',
    '2': 'Zaznacz %{smart_count}'
  },
  smile: 'Uśmiech!',
  startRecording: 'Rozpocznij nagrywanie',
  stopRecording: 'Zatrzymaj nagrywanie',
  takePicture: 'Zrób zdjęcie',
  timedOut: 'Przesyłanie trwa za długo, przerywanie.',
  unselectAllFilesFromFolderNamed: 'Odznacz wszystkie pliki z katalogu %{name}',
  unselectFileNamed: 'Odznacz plik %{name}',
  upload: 'Prześlij',
  uploadComplete: 'Przesyłanie zakończone',
  uploadFailed: 'Nie udało się przesłać',
  uploadPaused: 'Przesyłanie wstrzymane',
  uploadXFiles: {
    '0': 'Prześlij (%{smart_count})',
    '1': 'Prześlij (%{smart_count})',
    '2': 'Prześlij (%{smart_count})'
  },
  uploadXNewFiles: {
    '0': 'Prześlij (+%{smart_count})',
    '1': 'Prześlij (+%{smart_count})',
    '2': 'Prześlij (+%{smart_count})'
  },
  uploading: 'Przesyłanie',
  uploadingXFiles: {
    '0': 'Przesyłanie (%{smart_count})',
    '1': 'Przesyłanie (%{smart_count})',
    '2': 'Przesyłanie (%{smart_count})'
  },
  xFilesSelected: {
    '0': 'Wybrano %{smart_count}',
    '1': 'Wybrano %{smart_count}',
    '2': 'Wybrano %{smart_count}'
  },
  xMoreFilesAdded: {
    '0': '%{smart_count} plik dodany',
    '1': '%{smart_count} plików dodanych',
    '2': '%{smart_count} plików dodanych'
  },
  xTimeLeft: 'pozostało %{time}',
  youCanOnlyUploadFileTypes: 'Możesz przesłać tylko: %{types}',
  youCanOnlyUploadX: {
    '0': 'Nie możesz przesłać więcej plików niż: %{smart_count}',
    '1': 'Nie możesz przesłać więcej plików niż: %{smart_count}',
    '2': 'Nie możesz przesłać więcej plików niż: %{smart_count}'
  },
  youHaveToAtLeastSelectX: {
    '0': 'Musisz wybrać przynajmniej %{smart_count} plik',
    '1': 'Musisz wybrać przynajmniej %{smart_count} plików',
    '2': 'Musisz wybrać przynajmniej %{smart_count} plików'
  }
};

pl_PL.pluralize = function (n) {
  if (n === 1) {
    return 0;
  }

  return 1;
};

if (typeof window !== 'undefined' && typeof window.Uppy !== 'undefined') {
  window.Uppy.locales.pl_pl = pl_PL;
}

module.exports = pl_PL;
